// /Frontend/hoppla-admin/src/app/router.tsx

import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../features/auth/auth-context';
import { appRoutes } from './routes';

function RouterAuthShell(): JSX.Element {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

const routerFutureFlags = {
  v7_startTransition: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_skipActionErrorRevalidation: true,
  v7_relativeSplatPath: true,
  v7_partialHydration: true,
} as unknown as NonNullable<
  Parameters<typeof createBrowserRouter>[1]
>['future'];

const router = createBrowserRouter(
  [
    {
      element: <RouterAuthShell />,
      children: appRoutes,
    },
  ],
  {
    future: routerFutureFlags,
  },
);

export function AppRouter(): JSX.Element {
  return <RouterProvider router={router} />;
}

export default AppRouter;
